"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = list;
exports.batchUpdate = batchUpdate;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

var endpoints = {
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/nudge/list_active");
    }
  },
  batchUpdate: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/nudge/batchmodify");
    }
  }
};
exports.endpoints = endpoints;

/**
 * Returns a list of messages with nudge info
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @return {Promise<NudgeListResponse}
 */
function list(_x) {
  return _list.apply(this, arguments);
}

function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, optionals, _endpoints$list, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _list.apply(this, arguments);
}

/**
 * Batch update status for nudges
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {string[]} messageIds - Message IDs to update
 * @returns {Promise<APIResponse<void>>}
 */
function batchUpdate(_x2, _x3) {
  return _batchUpdate.apply(this, arguments);
}

function _batchUpdate() {
  _batchUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2, _ref3) {
    var messageIds, status, auth, optionals, _endpoints$batchUpdat, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            messageIds = _ref2.messageIds, status = _ref2.status;
            auth = _ref3.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              ids: messageIds,
              status: status
            }))(_utils.defaultOptionals);
            _endpoints$batchUpdat = endpoints.batchUpdate, method = _endpoints$batchUpdat.method, url = _endpoints$batchUpdat.url;
            _context2.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _batchUpdate.apply(this, arguments);
}
//# sourceMappingURL=email-nudges.js.map